/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IDefinition } from '../../../core/models/common/IDefinition';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { Oas20Schema } from './Oas20Schema';

/**
 * Constructor.
 * @param {string} name
 * @class
 * @extends Oas20Schema
 * @author eric.wittmann@gmail.com
 */
export class Oas20SchemaDefinition extends Oas20Schema implements IDefinition {
    /*private*/ _name : string;

    public constructor(name : string) {
        super();
        if(this._name===undefined) this._name = null;
        this._name = name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Schema#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        visitor.visitSchemaDefinition(this);
    }
}
Oas20SchemaDefinition["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20SchemaDefinition";
Oas20SchemaDefinition["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.common.IPropertyParent","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];




